import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import { Icon, Layout, Menu } from "antd";
import { login, logout } from "./Auth";

const { Sider } = Layout;
const SubMenu = Menu.SubMenu;

class NavMenu extends Component {
  state = { "collapsed": true };

  toggleCollapsed = () => {
    this.setState({ "collapsed": !this.state.collapsed });
  };

  render () {
    const { collapsed } = this.state,
      { auth, location } = this.props;
    return (
      <Sider
        collapsed={collapsed}
        collapsible
        onCollapse={this.toggleCollapsed}
      >
        <Menu
          inlineCollapsed={collapsed}
          mode="inline"
          selectedKeys={[location.pathname]}
          theme="dark"
        >
          {
            auth !== undefined
              ? <Menu.Item key="/logout" onClick={logout}>
                <Icon type="logout" />
                <span>Logout</span>
              </Menu.Item>
              : <Menu.Item key="/login" onClick={login}>
                <Icon type="login" />
                <span>Login</span>
              </Menu.Item>
          }
          {
            <Menu.Item key="/vvp_account_dump" >
              <Icon type="fire" style={{ color: '#00B8FF' }} />
              <span>VVP Account Dump</span>
              <NavLink className="nav-text" to="/vvp_account_dump"/>
            </Menu.Item>
          }
          {
            auth && auth.permissions.vdns && (
              <SubMenu
                key='vdns_manager'
                title={<span><Icon type="cluster"/><span>VDNS Manager</span></span>}
              >
                <Menu.Item key='/vdns_manager/records'>
                  <span>Records</span>
                  <NavLink className="nav-text" to="/vdns_manager/records"/>
                </Menu.Item>
                <Menu.Item key='/vdns_manager/clusters'>
                  <span>Clusters</span>
                  <NavLink className="nav-text" to="/vdns_manager/clusters"/>
                </Menu.Item>
                <Menu.Item key='/vdns_manager/services'>
                  <span>Services</span>
                  <NavLink className="nav-text" to="/vdns_manager/services"/>
                </Menu.Item>
              </SubMenu>
            )
          }
        </Menu>
      </Sider>
    );
  }
}

NavMenu.propTypes = {
  auth: PropTypes.object,
  location: PropTypes.object.isRequired,
};

export default withRouter(NavMenu);
